import HTTP from '../http'
import Location from './locationModel'

import { getCookie } from '../utils/cookies'

const locationService = {
  getAll () {
    let response = getCookie('danckuts.locations')
    if (response) {
      return Promise.resolve(JSON.parse(response))
    }

    return HTTP.post('', {
      query: `
        query {
          location {
            _key,
            id,
            name,
            email,
            phone,
            internet_booking,
            address {
              address1,
              address2,
              city,
              state,
              zip
            },
            position {
              lat,
              lng
            },
            schedule_type
          }
        }
      `
    }).then((res: any) => {
      const data = res.data.data.location.map((loc: any) => new Location(loc))
      // setCookie('danckuts.locations', JSON.stringify(data), '', 1)
      return data
    })
  },
  async getById (id: string) {
    if (!id) return

    const locations = await this.getAll()
    id = id.toUpperCase()
    return locations.find((loc: any) => loc._key === id || loc.id === id)
  },
  async getOnlineLocations () {
    const locations = await this.getAll()
    return locations.filter((loc: any) => loc.internet_booking)
  }
}

export default locationService
